<script setup>
import { ref } from 'vue';
import { storeToRefs } from "pinia";
import { useMailLogStore} from "../stores/maillog";
import { Right,CircleCloseFilled, Loading} from "@element-plus/icons-vue";


const store = useMailLogStore();
const { disableSingleSelectActions,singleMailSelectedData } = storeToRefs(store);
const showForwardDialog = ref(false)
const sendToEmail = ref('')

const attachments = ref('');
const attachedFiles = ref('');
const selectedFiles = ref({});
const fileList = ref([]);
const isSending = ref(false);
const uploadRef = ref(null);

const onOpen = (e) => {
    showForwardDialog.value = true;
    attachments.value = singleMailSelectedData.value?.attachments == 'true';
    attachedFiles.value = singleMailSelectedData.value?.dataFile;
}
const onConfirm = async (e) => {
    isSending.value = true;
    const form_data = new FormData();
    form_data.append('id', singleMailSelectedData.value['id']);
    form_data.append('to_email', sendToEmail.value);
    form_data.append('type', 'forward');
    form_data.append('includeAttachment', JSON.stringify(selectedFiles.value));

    Object.keys(fileList.value).forEach((key) => {
        form_data.append('file '+ key, fileList.value[key].raw);
    });

    await store.forwardEmail(form_data);
    
    sendToEmail.value = '';
    isSending.value = false;
    showForwardDialog.value = false;
}

const onCheckChange = (checked,checkbox) => {
    const checkedFile = attachedFiles.value.filter((file) => file.path === checkbox.target.name )[0];
    
    if(!checkedFile.exist){
        return;
    }
    if(checked){
        selectedFiles.value[checkbox.target.name] = checkbox.target.value;
    }
    else{
        delete selectedFiles.value[checkbox.target.name];
    }
}

const handleRemove = (file, uploadFiles) => {
  fileList.value = uploadFiles;
}

const handleOnChange = (uploadFile, uploadFiles) => {
    fileList.value = uploadFiles;
}

const closeDialog = (e) => {
  selectedFiles.value = {};
  uploadRef.value.clearFiles();
  sendToEmail.value = '';
  fileList.value = [];
}
</script>
<script>
</script>
<template>
    <span>
    <el-button title="Forward" :icon="Right" type="primary" :disabled="disableSingleSelectActions" 
    @click="onOpen" circle />
    <div class="wml-mail-forward">
      <el-dialog
        v-model="showForwardDialog"
        width="30%"
        :with-header="true"
        :show-close="false"
        @close="closeDialog"
      >
        <template #header="{ close, titleId, titleClass }">
            <div class="wml-mail-actions">
                <div class="wml-input-group">
                    Forward Email
                </div>
            </div>
            
            <el-button type="danger" :round="false" @click="close">
                <el-icon class="el-icon--left"><CircleCloseFilled /></el-icon>
                Close
            </el-button>
        </template>
      <el-row>
        <el-col :span="8">
          To
        </el-col>
        <el-col :span="16">
          <el-input v-model="sendToEmail"></el-input>  
        </el-col>
        <el-divider />
      </el-row>
      <el-row v-if="attachments" style="overflow: hidden;" >
        <el-col :span="8">
          Attached Files
        </el-col>
        <el-col :span="16">
          <el-checkbox v-for="(file,index) in attachedFiles" :key="index" :disabled="!file.exist"
          :label="file.exist ? file.name : file.name" :name="file.path" :value="file.path" :v-model="file.path"
          @change="(checked,event) => onCheckChange(checked,event)" validate-event="true" />
        </el-col>
        <el-divider />
      </el-row>
      <el-row>
        <el-col :span="8">
          Attachments
        </el-col>
        <el-col :span="16">
          <el-upload
              v-model="fileList"
              ref="uploadRef"
              class="upload-demo"
              multiple
              :on-remove="handleRemove"
              :on-change="handleOnChange"
          >
              <el-button type="primary">Click to upload</el-button>
          </el-upload>
        </el-col>
        <el-divider />
      </el-row>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="showForwardDialog = false">Cancel</el-button>
            <el-button :disabled="sendToEmail === ''" type="primary" :icon="isSending ? Loading : ''" @click="onConfirm">
              Confirm
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div> 
    </span>
  </template>
  
  
  <style scoped>
  .dialog-footer button:first-child {
    margin-right: 10px;
  }
  </style>